import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import firebase from "firebase/app";

import {
  ProxyList
} from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4,4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1,1)
    }
  }
}));


const Dashboard = props => {
  const classes = useStyles();
  
  firebase.auth().onAuthStateChanged(function(myuser) {
    if (!myuser) {
        props.history.replace('/sign-in')
        return

    }else{
      if (!myuser.emailVerified) {
        props.history.replace('/sign-in')
        return
      }
    }
  });


  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
      >
        <Grid
            item
            lg={12}
            md={12}
            xl={9}
            xs={12}
        >
          <ProxyList />
        </Grid>
        
      </Grid>
    </div>
  );

};

export default Dashboard;
